import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

export interface ParametrosHistorial {
  limite: number;
  offset: number;
}

export function useHistorialImportaciones(params: ParametrosHistorial) {
  return useQuery({
    queryKey: ['historial-importaciones', params.limite, params.offset],
    queryFn: () => cliente.importaciones.listar(params),
    staleTime: 10_000,
  });
}
